// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TDeleteSubscriptionRequest,
  TDeleteSubscriptionModel,
  IMappers,
  TDeleteSubscriptionResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IResponseSchema_delete_subscription } from '../../entities/entities/ResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createDeleteSubscriptionModel(parameters: TDeleteSubscriptionRequest): TDeleteSubscriptionModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'subscriptions',
    pathApi: '/v1/delete-subscription/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IDeleteSubscriptionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TDeleteSubscriptionRequest;
}

export async function fetchDeleteSubscription<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeleteSubscriptionOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDeleteSubscriptionResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDeleteSubscriptionModel(parameters),
    config,
  )) as FetchResponse<TDeleteSubscriptionResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IResponseSchema_delete_subscription, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDeleteSubscriptionResponse>;
}
